<template>

    <div v-if="this.showloader" class="loader-overlay">
        <div class="spinner"></div>
    </div>


    <div>
        <video ref="video" autoplay muted style="width: 1px; height: 1px; position: absolute;"></video>
        <canvas ref="canvas" style="display: none;"></canvas>
    </div>

    <div v-if="!loading" class="display-container">
        <div style="height: 100%" v-if="showServices">
            <lbrx-kiosk-first-theme v-model="validating" :popup="false" @setLanguage="setLanguage"
                @long-press="openQuantity" @check-service="checkService" @validate="validateServices"
                v-if="themeTemplate.theme === 'firstTheme'" :themeTemplate="themeTemplate"
                :services="services"></lbrx-kiosk-first-theme>
            <lbrx-kiosk-second-theme v-model="validating" :popup="false" @setLanguage="setLanguage"
                @long-press="openQuantity" @check-service="checkService" @validate="validateServices"
                v-else-if="themeTemplate.theme === 'secondTheme'" :themeTemplate="themeTemplate"
                :services="services"></lbrx-kiosk-second-theme>
            <lbrx-kiosk-third-theme v-model="validating" :popup="false" @setLanguage="setLanguage"
                @long-press="openQuantity" @check-service="checkService" @validate="validateServices"
                v-else-if="themeTemplate.theme === 'thirdTheme'" :themeTemplate="themeTemplate"
                :services="services"></lbrx-kiosk-third-theme>
            <lbrx-kiosk-fourth-theme v-model="validating" :popup="false" @setLanguage="setLanguage"
                @long-press="openQuantity" @check-service="checkService" @validate="validateServices"
                v-else-if="themeTemplate.theme === 'fourthTheme'" :themeTemplate="themeTemplate"
                :services="services"></lbrx-kiosk-fourth-theme>
            <lbrx-kiosk-fifth-theme v-model="validating" :popup="false" @long-press="openQuantity"
                @check-service="checkService" @validate="validateServices"
                v-else-if="themeTemplate.theme === 'fifthTheme' || themeTemplate.theme === 'seventhTheme'"
                :services="services" :themeTemplate="themeTemplate"></lbrx-kiosk-fifth-theme>
            <lbrx-kiosk-sixth-theme :isRecording="this.isRecordingIcon" :isListening="this.isListening" v-model="validating" :popup="false"
                @long-press="openQuantity" @cancel="cancel" @check-service="checkService"
                @check-category="checkCategory" @validate="validateServices"
                v-else-if="themeTemplate.theme === 'sixthTheme' || themeTemplate.theme === 'eighthTheme'"
                :services="services" :categories="categories" :categoryChosen="categoryChosen"
                :themeTemplate="themeTemplate"></lbrx-kiosk-sixth-theme>
        </div>

        <div v-else>
            <lbrx-print-ticket-box ref="sendTicketRef" :aiPhoneNumber=this.aiPhoneNumber @testFunction="stopAudio"
                @getPhoneNumber="this.autoNumber" @resetAllData="getData" @resetAll="resetAll" @cancel_idle="cancelIdle"
                @start_idle="startIdle" @sending="validating = !validating" @cancel="cancelClicked" :services="services"
                :categories="categories" v-model="validating" :directPrint="directPrint" :themeTemplate="themeTemplate"
                :showBarcode="themeTemplate.allowBarCode"></lbrx-print-ticket-box>
        </div>
    </div>
    <div style="height: 100vh;display: flex" v-else>
        <div class="spinner-border" :style="{ 'color': themeTemplate.secondaryColor }"
            style="margin: auto;height: 15vmin;width: 15vmin;font-size: 6vmin" role="status">
        </div>
    </div>
    <lbrx-kiosk-popup v-if="showPopup" @close="showPopup = false" v-model="showPopup" :closable="isClosable"
        :box-height="boxHeight" :content="boxContent" :icon="boxIcon" :text-color="boxTextColor"
        :box-background="boxBackGround" :icon-color="boxIconColor"></lbrx-kiosk-popup>
    <lbrx-kiosk-services-popup :themeTemplate="themeTemplate" :service="clickedService"
                               v-if="showServicesPopup && clickedService" @close="validateClickedService"
                               v-model="showServicesPopup"></lbrx-kiosk-services-popup>
                               <lbrx-quantity-picker-popup v-if="showQuantityPicker" @submit-quantity="setQuantity"
                                @close="showQuantityPicker = false, setQuantityFor = null" v-model="showQuantityPicker"
                                :max="20" :min="1" :themeTemplate="themeTemplate"></lbrx-quantity-picker-popup>
</template>

<script>
import { kioskService } from "@/_services/kiosk.service";
import LbrxKioskFirstTheme from "@/components/LbrxKioskFirstTheme.vue";
import LbrxKioskSecondTheme from "@/components/LbrxKioskSecondTheme.vue";
import LbrxKioskThirdTheme from "@/components/LbrxKioskThirdTheme.vue";
import LbrxKioskFourthTheme from "@/components/LbrxKioskFourthTheme.vue";
import LbrxKioskFifthTheme from "@/components/LbrxKioskFifthTheme.vue";
import LbrxKioskSixthTheme from "@/components/LbrxKioskSixthTheme.vue";
import LbrxPrintTicketBox from "@/components/LbrxPrintTicketsBox.vue";
import LbrxKioskPopup from "@/components/LbrxKioskPopup.vue";
import LbrxKioskServicesPopup from "@/components/LbrxKioskServicesPopup.vue";
import LbrxQuantityPickerPopup from "@/components/LbrxQuantityPickerPopup.vue";

import router from "@/router";
import { locale } from "moment";
import * as faceapi from "face-api.js";
import { isAIEnabled } from "@/_helpers/ai-features";

export default {
    name: 'KioskWaitingQueue',
    inject: ['echo', 'display'],
    components: {

        LbrxQuantityPickerPopup,
        LbrxKioskServicesPopup,
        LbrxKioskPopup,
        LbrxPrintTicketBox,
        LbrxKioskSixthTheme,
        LbrxKioskFifthTheme,
        LbrxKioskFourthTheme,
        LbrxKioskThirdTheme,
        LbrxKioskSecondTheme,
        LbrxKioskFirstTheme,
    },
    data() {
        return {
            unclearAudioSound:"",
            unclearAudioId:"",
            waitingTimeAudio:"",
            ticketWaitingTime:0,
            waiting_time_target:0,
            finalVoiceSound:"",
            finalVoiceId:"",
            allow_sms_ticket:1,
            isRecordingIcon:false,
            peakVolume: 0,
            language: "",
            targetWaitingTime: 0,
            serviceVoiceId: "",
            serviceVoiceSound: "",
            waitingTimeVoiceId: "",
            waitingTimeVoiceSound: "",
            waitingTimeForQueue: 0,
            sucessVoiceId: "",
            sucessVoiceSound: "",
            errorVoiceId: "",
            errorVoiceSound: "",
            welcomeVoiceId: "",
            welcomeVoiceSound: "",
            kioskConfig: {},
            showloader: false,
            testIfExist: null,
            aiPhoneNumber: "33333333",
            returnNumberBase64: false,
            minVolumeThreshold: 10,
            autoSelectService: true,
            returnBase64: false,
            silenceTimeout: null,
            audioContext: null,
            analyser: null,
            microphone: null,
            isRecording: false,
            mediaRecorder: null,
            audioChunks: [],
            audioBase64: '',
            autoNumber: null,
            nextAudioPath: null,
            audio: null,
            audioPath: null,
            audio2: null,
            audioQueue: [],
            isPlaying: false,
            base64Audio: null,
            isListening: false,
            chatgptText: null,
            speechToText: null,
            content: null,
            timerCountFromLocaleStorage: true,
            timerStatus: true,
            voice: false,
            timerInterval: null,
            isTimerActive: false,
            timer: null,
            age: null,
            gender: null,
            expression: null,
            allowIdle: true,
            showQuantityPicker: false,
            setQuantityFor: null,
            validating: false,
            showServices: true,
            clickedService: null,
            showServicesPopup: false,
            themeTemplate: null,
            locale: 'fr',
            config: {},
            loading: true,
            services: [],
            categories: [],
            category: {},
            onLine: navigator.onLine,
            showBackOnline: false,
            boxHeight: '40%',
            boxContent: '',
            boxIcon: 'loader',
            boxTextColor: '',
            isClosable: false,
            boxBackGround: "#FFFFFF",
            boxIconColor: '',
            showPopup: false,
            directPrint: false,
            idleTimeout: null,
            numberOfChecked: 0,
            nextCountdown: null,
            categoryChosen: false
        }
    },
    methods: {

        playAudio(filePath) {
            this.audioQueue.push(filePath);
            if (!this.isPlaying) {
                this.playNextInQueue();
            }
            //console.log("this", this.audioQueue)
        },
        playNextInQueue() {
            //console.log("this", this.audioQueue.length)
            if (this.audioQueue.length === 0) {
                this.isPlaying = false;
                return;
            }

            this.nextAudioPath = this.audioQueue.shift();
            this.audio = new Audio(this.nextAudioPath);
            this.isPlaying = true;

            // Store the currently playing Audio object
            this.serviceVoiceSound = this.audio;

            this.audio.play()
                .then(() => {
                    //(`Audio ${this.nextAudioPath} played successfully`);
                    this.audio.onended = () => {
                        this.isPlaying = false;
                        this.playNextInQueue();
                    };
                })
                .catch((error) => {
                    console.error(`Error playing audio ${this.nextAudioPath}:`, error);
                    this.isPlaying = false;
                    this.playNextInQueue();
                });
        },
        async playVoice() {
        // Check if AI features are enabled
        if (!isAIEnabled()) {
           // console.log('AI features disabled - skipping voice playback');
            return Promise.resolve();
        }

        this.language = localStorage.getItem('Language') || 'fr';
        this.kioskConfig = JSON.parse(window.localStorage.getItem("kiosk") || "b");
        this.welcomeVoiceId = JSON.parse(this.kioskConfig.config_v2).voices.welcome[this.language].id;
        
        return new Promise((resolve, reject) => {
            kioskService.getVoiceFromText(this.welcomeVoiceId)
                .then((res) => {
                  //  console.log("res is playvoice", res);
                    this.welcomeVoiceSound = res.data.content;
                    
                    const audio = new Audio(`data:audio/mp3;base64,${this.welcomeVoiceSound}`);
                    audio.play();

                    // When audio finishes, resolve the promise
                    audio.onended = () => {
                       // console.log("Audio playback completed.");
                        resolve();
                    };

                    audio.onerror = (err) => {
                        console.error("Audio playback error", err);
                        reject(err);
                    };
                })
                .catch((err) => {
                    console.error("Error fetching voice", err);
                    reject(err);
                });
        });
    },

        playServiceVoice(service) {
            // Check if AI features are enabled
            if (!isAIEnabled()) {
               // console.log('AI features disabled - skipping service voice');
                return;
            }

            this.language = localStorage.getItem('Language') || 'fr'
            if (service.voice) {
                this.serviceVoiceId = service.voice[this.language].id;
                kioskService.getVoiceFromText(this.serviceVoiceId).then((res) => {
                   // console.log("res is playservice", res);
                    this.serviceVoiceSound = res.data.content;
                }).catch((err) => {
                  //  console.log(err)
                    this.showloader = false;
                }).finally(() => {
                    this.serviceVoiceSound = this.playAudio(`data:audio/mp3;base64,${this.serviceVoiceSound}`);

                });
            }
        },

        playSuccessVoice() {
            // Check if AI features are enabled
            if (!isAIEnabled()) {
               // console.log('AI features disabled - skipping success voice');
                return;
            }

            this.language = localStorage.getItem('Language') || 'fr'
            this.kioskConfig = JSON.parse(window.localStorage.getItem("kiosk") || "b");
            this.sucessVoiceId = JSON.parse(this.kioskConfig.config_v2).voices.ticket[this.language].id;
            kioskService.getVoiceFromText(this.sucessVoiceId).then((res) => {
               // console.log("res is playsucess", res);
                this.sucessVoiceSound = res.data.content;

            }).catch((err) => {
             //   console.log(err)
                this.showloader = false;
            }).finally(() => {
                this.playAudio(`data:audio/mp3;base64,${this.sucessVoiceSound}`)
            });
            //this.playAudio('/sounds/succes.mp3');
        },
        playErrorVoice() {
            // Check if AI features are enabled
            if (!isAIEnabled()) {
              //  console.log('AI features disabled - skipping error voice');
                return;
            }

            this.language = localStorage.getItem('Language') || 'fr'
            // this.playAudio('/sounds/error.mp3');
            this.kioskConfig = JSON.parse(window.localStorage.getItem("kiosk") || "b");
            this.errorVoiceId = JSON.parse(this.kioskConfig.config_v2).voices.error[this.language].id;
            kioskService.getVoiceFromText(this.errorVoiceId).then((res) => {
             //   console.log("res is error", res);
                this.errorVoiceSound = res.data.content;

            }).catch((err) => {
              //  console.log(err)
                this.showloader = false;
            }).finally(() => {
                this.playAudio(`data:audio/mp3;base64,${this.errorVoiceSound}`)
            });
        },



        playFinalVoice() {
    // Check if AI features are enabled
    if (!isAIEnabled()) {
      //  console.log('AI features disabled - skipping final voice');
        return;
    }

    this.language = localStorage.getItem('Language') || 'fr';
    this.waiting_time_target = localStorage.getItem('waiting_time_target') || 0;
    this.ticketWaitingTime = localStorage.getItem('ticketWaitingTime') || 0;
   // console.log("sound waiting",this.ticketWaitingTime)
    if (this.ticketVoiceSound && typeof this.ticketVoiceSound.pause === 'function' && !this.ticketVoiceSound.paused) {
        this.ticketVoiceSound.pause();
        this.ticketVoiceSound.currentTime = 0;
    }

    this.kioskConfig = JSON.parse(window.localStorage.getItem("kiosk") || "{}");
    this.finalVoiceId = JSON.parse(this.kioskConfig.config_v2).voices.postAction[this.language].id;

    kioskService.getVoiceFromText(this.finalVoiceId)
        .then((res) => {
          //  console.log("res is playfinal", res);
            this.finalVoiceSound = res.data.content;
        })
        .catch((err) => {
          //  console.log(err);
            this.showloader = false;
        })
        .finally(() => {
            this.finalAudio = new Audio(`data:audio/mp3;base64,${this.finalVoiceSound}`);
            this.finalAudio.play();

            // Listen for when finalAudio finishes playing, then play the next audio
            this.finalAudio.onended = () => {
               if(this.ticketWaitingTime > this.waiting_time_target*60)
                this.playWaitingTimeTarget();
            };
        });
},


playUnclearAudio() {
    // Check if AI features are enabled
    if (!isAIEnabled()) {
       // console.log('AI features disabled - skipping unclear audio');
        return;
    }

    this.language = localStorage.getItem('Language') || 'fr';
    this.kioskConfig = JSON.parse(window.localStorage.getItem("kiosk") || "{}");
    this.unclearAudioId = JSON.parse(this.kioskConfig.config_v2).voices.unclearAudio[this.language].id;

    kioskService.getVoiceFromText(this.unclearAudioId)
        .then((res) => {
          //  console.log("res is playfinal", res);
            this.unclearAudioSound = res.data.content;
        })
        .catch((err) => {
           // console.log(err);
            this.showloader = false;
        })
        .finally(() => {
            this.finalAudio = new Audio(`data:audio/mp3;base64,${this.unclearAudioSound}`);
            this.finalAudio.play();
        });
        },


playWaitingTimeTarget() {
    // Check if AI features are enabled
    if (!isAIEnabled()) {
       // console.log('AI features disabled - skipping waiting time voice');
        return;
    }

    this.language = localStorage.getItem('Language') || 'fr';
    this.queue = JSON.parse(window.localStorage.getItem("queues") || "");
    this.kioskConfig = JSON.parse(window.localStorage.getItem("kiosk") || "{}");
    
    this.waitingTimeVoiceId = JSON.parse(this.kioskConfig.config_v2).voices.waititngTime[this.language].id;
    
    kioskService.getVoiceFromText(this.waitingTimeVoiceId)
        .then((res) => {
          //  console.log("res is playwaiting", res);
            this.waitingTimeVoiceSound = res.data.content;
        })
        .catch((err) => {
           // console.log(err);
            this.showloader = false;
        })
        .finally(() => {
            this.waitingTimeAudio = new Audio(`data:audio/mp3;base64,${this.waitingTimeVoiceSound}`);
            this.waitingTimeAudio.play();
        });
},


        stopAudio() {
            if (this.audio) {
                this.audio.pause(); // Stop the audio
                this.audio.currentTime = 0; // Reset the playback position
                this.isPlaying = false; // Reset the state
                this.audioQueue = []; // Clear the queue if needed
            }

        },

        firstTouchVoice() {
            // Only play sound if AI features are enabled (business.ai_features === false)
            if (!isAIEnabled()) {
                //console.log('AI features disabled - skipping first touch voice');
                return;
            }
            
            this.audioPath = process.env.VUE_APP_FIRST_TOUCH;
            this.audio2 = new Audio(this.audioPath);
            this.audio2.play();
        },

        async initWebcam() {
            // Check if AI features are enabled
            if (!isAIEnabled()) {
               // console.log('AI features disabled - skipping webcam initialization');
                this.loading = false;
                return;
            }

            this.loading = true;
            await Promise.all([
                faceapi.nets.tinyFaceDetector.loadFromUri("/models"),
                faceapi.nets.ageGenderNet.loadFromUri("/models"),
                faceapi.nets.faceExpressionNet.loadFromUri("/models"),
            ]);
            this.loading = false;

            const video = this.$refs.video;

            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                video.srcObject = stream;

                video.addEventListener("loadedmetadata", () => {
                    this.detectAgeGenderExpression();
                });
            } catch (error) {
                console.error("Error accessing webcam: ", error);
            }
        },

        async detectAgeGenderExpression() {
            // Check if AI features are enabled
            if (!isAIEnabled()) {
                //console.log('AI features disabled - skipping face detection');
                return;
            }

            this.timerCountFromLocaleStorage = localStorage.getItem("timerCount");
            const video = this.$refs.video;
            const displaySize = { width: video.videoWidth, height: video.videoHeight };
            setInterval(async () => {
                const detections = await faceapi
                    .detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
                    .withAgeAndGender()
                    .withFaceExpressions();
                if (detections) {
                    if (!this.timerInterval && this.timerStatus) {
                        this.startTimer();
                        this.isRecordingIcon = true;
                    }
                    this.age = detections.age;
                   // console.log("age: ", this.age);
                    this.gender = detections.gender;
                    const expressions = detections.expressions;
                    const maxExpression = Object.keys(expressions).reduce((a, b) =>
                        expressions[a] > expressions[b] ? a : b
                    );
                    this.expression = maxExpression;
                } else {
                    this.stopTimer();
                    this.isRecordingIcon = false;
                }
            }, 1000);
        },

        async startRecording() {
            // Check if AI features are enabled
            if (!isAIEnabled()) {
               // console.log('AI features disabled - skipping audio recording');
                return;
            }

            this.peakVolume = 0;
            try {
                this.isListening = true;
                const stream = await navigator.mediaDevices.getUserMedia({
                    audio: {
                        sampleRate: 16000,
                        noiseSuppression: true,
                        echoCancellation: true,
                        autoGainControl: true
                    }
                });
                this.mediaRecorder = new MediaRecorder(stream);
                this.audioChunks = [];
                this.isRecording = true;

                const audioContext = new AudioContext();
                const source = audioContext.createMediaStreamSource(stream);
                const analyser = audioContext.createAnalyser();
                analyser.fftSize = 512;

                const dataArray = new Uint8Array(analyser.frequencyBinCount);
                source.connect(analyser);

                // Silence detection settings
                let silenceThreshold = 20; // Increased threshold to filter out background noise
                let silenceTimeout = 4000; // 2 seconds of silence to stop
                let silenceTimer = null;

                // Variables for volume calculation
                let startTime = Date.now();
                let totalVolume = 0;
                let sampleCount = 0;

                this.mediaRecorder.ondataavailable = (event) => {
                    this.audioChunks.push(event.data);
                };

                this.mediaRecorder.start();

                // Monitor audio levels for silence detection and volume calculation
                const monitorAudio = () => {
                    analyser.getByteTimeDomainData(dataArray);

                    // Calculate volume (RMS)
                    let sum = 0;
                    for (let i = 0; i < dataArray.length; i++) {
                        const value = Math.abs(dataArray[i] - 128); // Convert to signed value
                        sum += value * value;
                    }
                    const rms = Math.sqrt(sum / dataArray.length); // Root Mean Square (RMS) volume
                    const volume = Math.round(rms); // Volume level (0-128)

                    // Update volume metrics
                    totalVolume += volume;
                    sampleCount++;
                    if (volume > this.peakVolume) {
                        this.peakVolume = volume;
                    }

                    // Log volume metrics
                    //console.log(`Current Volume: ${volume}, Peak Volume: ${this.peakVolume}`);

                    // Silence detection logic
                    const isSilent = volume < silenceThreshold; // Check if volume is below the silence threshold

                    if (isSilent) {
                        if (!silenceTimer) {
                            // Start silence timer
                            silenceTimer = setTimeout(() => {
                                //console.log('Silence detected, stopping recording...');
                                this.stopRecording();
                                clearInterval(monitoringInterval);
                            }, silenceTimeout);
                        }
                    } else {
                        // Reset silence timer if sound is detected
                        if (silenceTimer) {
                            clearTimeout(silenceTimer);
                            silenceTimer = null;
                        }
                    }

                    // Check if the volume is above the minimum threshold for valid speech
                    if (volume > this.minVolumeThreshold) {
                       // console.log('Valid speech detected.');
                    } else {
                       // console.log('Background noise or silence detected.');
                    }
                };

                // Run audio monitoring at regular intervals
                const monitoringInterval = setInterval(monitorAudio, 100);

                // Log duration when recording stops
                this.mediaRecorder.onstop = () => {
                    const duration = (Date.now() - startTime) / 1000; // Duration in seconds
                    //console.log(`Recording Duration: ${duration.toFixed(2)} seconds`);
                };

            } catch (error) {
                console.error('Error accessing microphone:', error);
            }
        },

        stopRecording() {
            if (this.mediaRecorder) {
                this.mediaRecorder.stop();
                this.mediaRecorder.onstop = async () => {
                    if (this.returnBase64) {
                        const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
                        this.audioBase64 = await this.convertToBase64(audioBlob);
                       // console.log('Audio Base64:', this.audioBase64);
                        this.showloader = true;
                        this.isListening = false;
                       // console.log("Peak volume is", this.peakVolume);
                        if (this.peakVolume > this.minVolumeThreshold) {
                            setTimeout(() => {
                                this.startConversation();
                            }, 3000);
                        } else {
                            this.showloader = false;
                            this.stopTimerAfterRecoarding();
                            this.playUnclearAudio();


                        }
                    } else {
                      //  console.log('Recording stopped and discarded.');
                        this.audioChunks = []; // Clear the audio data
                        this.isListening = false;
                    }

                    this.isRecording = false;
                };
            }
        },

        convertToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    const base64 = reader.result.split(',')[1]; // Remove the "data:audio/wav;base64," prefix
                    resolve(base64);
                };
                reader.onerror = reject;
            });
        },



        // async startRecordingForNumber() {
        //     try {
        //         this.isListening = true;
        //         const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        //         this.mediaRecorder = new MediaRecorder(stream);
        //         this.audioChunks = [];
        //         this.isRecording = true;

        //         const audioContext = new AudioContext();
        //         const source = audioContext.createMediaStreamSource(stream);
        //         const analyser = audioContext.createAnalyser();
        //         analyser.fftSize = 512;

        //         const dataArray = new Uint8Array(analyser.frequencyBinCount);
        //         source.connect(analyser);

        //         // Silence detection settings
        //         let silenceThreshold = 10; // Adjust the threshold for silence (0-255)
        //         let silenceTimeout = 2000; // 4 seconds of silence to stop
        //         let silenceTimer = null;

        //         this.mediaRecorder.ondataavailable = (event) => {
        //             this.audioChunks.push(event.data);
        //         };

        //         this.mediaRecorder.start();

        //         // Monitor audio levels for silence detection
        //         const monitorAudio = () => {
        //             analyser.getByteTimeDomainData(dataArray);

        //             const isSilent = dataArray.every((value) => Math.abs(value - 128) < silenceThreshold);

        //             if (isSilent) {
        //                 if (!silenceTimer) {
        //                     // Start silence timer
        //                     silenceTimer = setTimeout(() => {
        //                         console.log('Silence detected, stopping recording...');
        //                         this.stopRecordingForNumber();
        //                         clearInterval(monitoringInterval);
        //                     }, silenceTimeout);
        //                 }
        //             } else {
        //                 // Reset silence timer if sound is detected
        //                 if (silenceTimer) {
        //                     clearTimeout(silenceTimer);
        //                     silenceTimer = null;
        //                 }
        //             }
        //         };

        //         // Run audio monitoring at regular intervals
        //         const monitoringInterval = setInterval(monitorAudio, 100);

        //     } catch (error) {
        //         console.error('Error accessing microphone:', error);
        //     }
        // },

        // stopRecordingForNumber() {
        //     if (this.mediaRecorder) {
        //         this.mediaRecorder.stop();
        //         this.mediaRecorder.onstop = async () => {
        //             if (this.returnNumberBase64) {
        //                 const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
        //                 this.audioBase64 = await this.convertToBase64ForNumber(audioBlob);
        //                 console.log('Audio Base64:', this.audioBase64);
        //                 this.showloader = true;
        //                 this.isListening = false;
        //                 setTimeout(() => {
        //                     this.startConversation();
        //                 }, 3000);
        //             }

        //             else {
        //                 console.log('Recording stopped and discarded.');
        //                 this.audioChunks = []; // Clear the audio data
        //                 this.isListening = false;
        //             }

        //             this.isRecording = false;
        //         };
        //     }
        // },

        // convertToBase64ForNumber(blob) {
        //     return new Promise((resolve, reject) => {
        //         const reader = new FileReader();
        //         reader.readAsDataURL(blob);
        //         reader.onloadend = () => {
        //             const base64 = reader.result.split(',')[1];
        //             resolve(base64);
        //         };
        //         reader.onerror = reject;
        //     });
        // },

        async startConversation() {
            this.testIfExist = localStorage.getItem("testIfExist") || "";
           // console.log("testIfExist is", this.testIfExist)
            const formData = new FormData();
            let servicesTitle = this.services.map(service => service.title).join(',');
            formData.append('base64', this.audioBase64);
            formData.append('services', servicesTitle);
           // console.log("services titles ", servicesTitle)
            kioskService.getVoice(formData).then((res) => {
              //  console.log("res is startconversation", res.content);
                this.content = res.response.transaction_type;
                if (this.autoSelectService == true) {
                    this.autoCheckService(this.content);
                }
                else {
                    if (this.testIfExist == 'true') {
                      //  console.log("dkhal lel loula")
                        this.showloader = false;
                        this.$refs.sendTicketRef.sendTicketWithNumber({ country_prefix: '+216', phone_number: this.aiPhoneNumber, internal_id: null });

                    }
                    else {
                       // console.log("dkhal lel thenya")
                        this.showloader = false;
                        this.$refs.sendTicketRef.sendTicketWithNumber({ country_prefix: '+216', phone_number: this.aiPhoneNumber, internal_id: null });
                        setTimeout(() => {
                            this.$refs.sendTicketRef.continueProcess();
                        }, 3000);
                    }
                }
            }).catch((err) => {
                this.playErrorVoice();
               // console.log(err)
                this.stopTimerAfterRecoarding();
                this.showloader = false;
            }).finally(() => {
                this.showloader = false;
            });
        },

        // async startConversation() {
        //     this.testIfExist = localStorage.getItem("testIfExist") ||"";


        //     console.log("testIfExist is", this.testIfExist)
        //     const formData = new FormData();
        //     let servicesTitle = this.services.map(service => service.title).join(',');
        //     formData.append('voice', this.audioBase64);
        //     formData.append('words', servicesTitle);
        //     console.log("services titles ", servicesTitle)
        //     kioskService.sendDataToChatGpt(formData).then((res) => {
        //         console.log("res is", res.content);
        //         this.content = res.content;
        //         if(this.autoSelectService == true){
        //             this.autoCheckService(this.content);
        //         }
        //         else {
        //             if (this.testIfExist == 'true') {
        //                 console.log("dkhal lel loula")
        //                 this.showloader = false;
        //                 this.$refs.sendTicketRef.sendTicketWithNumber({ country_prefix: '+216', phone_number: this.aiPhoneNumber, internal_id: null });

        //             }
        //             else {
        //                 console.log("dkhal lel thenya")
        //                 this.showloader = false;
        //                 this.$refs.sendTicketRef.sendTicketWithNumber({ country_prefix: '+216', phone_number: this.aiPhoneNumber, internal_id: null });
        //                 setTimeout(() => {
        //                     this.$refs.sendTicketRef.continueProcess();
        //                 }, 3000);
        //             }
        //         }
        //     }).catch((err) => {
        //         this.playErrorVoice();
        //         console.log(err)
        //         this.showloader = false;
        //     }).finally(() => {
        //         this.showloader = false;
        //     });
        // },

        async startTimer() {
        // Don't start timer if AI features are disabled
        if (!isAIEnabled()) {
          //  console.log('AI features disabled - skipping timer');
            return;
        }

      //  console.log(this.isTimerActive);
        if (this.isTimerActive) return;
        this.isTimerActive = true;
        this.autoSelectService = true;

        this.timerInterval = setInterval(async () => {
            this.timer += 1;
          //  console.log("timer is active", this.timer);

            if (this.timer > process.env.VUE_APP_DETECTION_TIME) {
                this.returnBase64 = true;
                this.returnNumberBase64 = true;
              //  console.log(this.voice);

                if (!this.voice) {
                    this.voice = true;
                    await this.playVoice();  // Wait for audio to finish
                  //  console.log("Start recording");
                    this.startRecording();
                }
            }
        }, 1000);
    },




        cancelTimer() {
            this.timerStatus = false
            this.timer = 0;
        },


        stopTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timer = 0;
                this.timerInterval = null;

                setTimeout(() => {
                    this.voice = false;
                    this.returnBase64 = false;
                    this.isListening = false;
                    this.stopRecording(); // Stop recording immediately

                }, 5000);
            }
            this.isTimerActive = false;
        },
        stopTimerAfterRecoarding() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timer = 0;
                this.timerInterval = null;

                setTimeout(() => {
                    this.voice = false;
                    this.returnBase64 = false;
                    this.isListening = false;
                    this.stopRecording(); // Stop recording immediately

                }, 5000);
            }
            this.isTimerActive = false;
        },
        cancelClicked() {
            this.returnNumberBase64 = false;
            this.returnBase64 = false;
            // this.stopRecordingForNumber();
            this.stopAudio();
            this.firstTouchVoice();
           // console.log("boutton retour");
            this.startTimer();
            this.voice = false;
            this.timerStatus = true;
            this.clickedService = null;
            this.setQuantityFor = null;
            this.showQuantityPicker = false;
            this.validating = true;
            this.services = [];
            this.setServices();
            this.showPopup = false;
            this.numberOfChecked = 0;
            this.directPrint = false;
            this.showServicesPopup = false;
            clearTimeout(this.idleTimeout);
            clearTimeout(this.nextCountdown);
            this.setIdleTimeout();
            this.showServices = true;
            this.validating = false;
            this.allowIdle = true;
        },
        resetAll() {
            this.setLanguage(JSON.parse(JSON.parse(window.localStorage.getItem('kiosk')).config).default_language);
            this.clickedService = null;
            this.setQuantityFor = null;
            this.showQuantityPicker = false;
            this.validating = true;
            this.services = [];
            this.categories = [];
            this.categoryChosen = false;
            this.setServices();
            this.getCategories();
            this.showPopup = false;
            this.numberOfChecked = 0;
            this.directPrint = false;
            this.showServicesPopup = false;
            clearTimeout(this.idleTimeout);
            clearTimeout(this.nextCountdown);
            this.setIdleTimeout();
            this.showServices = true;
            this.validating = false;
            this.allowIdle = true;
        },
        setLanguage(lang) {
            localStorage.setItem('Language', lang)
            this.$i18n.locale = localStorage.getItem('Language')
        },
        setServices() {
            if (window.localStorage.getItem("services")) {
                this.services = JSON.parse(window.localStorage.getItem("services"));
                this.loading = false;
            } else {
                this.loading = true;
                kioskService.loadServices().then(() => {
                    this.setServices();
                })
            }
        },
        showErrorPopup(errorText) {
            this.showPopup = false;
            this.boxIcon = 'error';
            this.isClosable = true;
            this.boxContent = errorText;
            this.boxTextColor = '#EB5757'
            this.boxBackGround = "#FFFFFF";
            this.boxIconColor = '#EB5757';
            this.boxHeight = "40%";
            this.showPopup = true;
        },
        validateClickedService() {
            this.clickedService.checked = false;
            this.clickedService.child.forEach((c) => {
                if (c.checked) {
                    this.clickedService.checked = true;
                }
            })
            this.disableOtherQueues(this.clickedService);
            this.showServicesPopup = false;
        },
        checkService(service) {

            clearTimeout(this.nextCountdown)
            clearTimeout(this.idleTimeout);
            if (service.disabled || this.validating)
                return;
            if (service.child && service.child.length > 0) {
                this.clickedService = service;
                this.showServicesPopup = true;
            } else {
                this.services[this.services.indexOf(service)].checked = !this.services[this.services.indexOf(service)].checked;
                this.firstTouchVoice();
                this.stopTimer();
                this.startTimer();
               // console.log("testsss", this.services[this.services.indexOf(service)].checked)
                if (this.services[this.services.indexOf(service)].checked) {
                    this.playServiceVoice(service);

                }
                if (!service.checked) {
                    if (this.numberOfChecked > 0)
                        this.numberOfChecked--;
                    service.qte = null;
                } else {
                    this.numberOfChecked++;
                }
                if (this.numberOfChecked > 0) {
                    this.startNextPageCountdown();
                }
                this.disableOtherQueues(service);
            }
        },
        autoCheckService(serviceName) {
            clearTimeout(this.nextCountdown);
            clearTimeout(this.idleTimeout);
            if (this.validating) return;
            setTimeout(() => {
                const service = this.services.find(s => s.name === serviceName || s.title === serviceName);
              //  console.log("service hedha", service);
                if (service) {
                    setTimeout(() => {
                        this.autoValidateServices();
                        // this.playSuccessVoice();
                        this.showloader = false;
                        this.autoSelectService = false;
                    }, 1000);
                    // setTimeout(() => {
                    //     this.returnBase64 = true;
                    //     console.log("het num", "status", this.returnNumberBase64);
                    //     this.startRecordingForNumber();
                    // }, 9000);
                }
                else {
                    this.playErrorVoice();
                    this.showloader = false;
                    this.stopTimer();
                    this.startTimer();
                }
                if (!service || service.disabled) {
                 //   console.log("Service not found or disabled:", serviceName);
                   // console.log("raja3 error audio")
                    return;
                }

                if (service.child && service.child.length > 0) {
                    this.clickedService = service;
                    this.showServicesPopup = true;
                } else {
                    setTimeout(() => {
                      //  console.log("dkhal", service.checked);
                        if (service.checked == false) {
                            service.checked = !service.checked;
                        }
                    }, 2000);
                    service.checked = !service.checked;
                  //  console.log("testsss", service.checked)
                    if (!service.checked) {
                        if (this.numberOfChecked > 0) {
                            this.numberOfChecked--;
                        }
                        service.qte = null;
                    } else {
                        this.numberOfChecked++;
                    }

                    if (this.numberOfChecked > 0) {
                        this.startNextPageCountdown();
                    }

                    this.disableOtherQueues(service);
                }
            }, 2000);
        },

        startNextPageCountdown() {
            clearTimeout(this.idleTimeout);
            clearTimeout(this.nextCountdown);
            if (this.themeTemplate.onServiceSelect != null) {
                if (this.themeTemplate.onServiceSelect.status) {
                  //  console.log("setting next page timeout");
                    this.nextCountdown = setTimeout(() => {
                        this.validateServices();
                        this.setIdleTimeout();
                    }, this.themeTemplate.onPrintTicket.timeout);
                }
            }
        },
        openQuantity(service) {
            if (!JSON.parse(JSON.parse(window.localStorage.getItem("kiosk")).config).allow_quantity_services)
                return;
            if (service.child)
                if (service.child.length)
                    return;
            this.setQuantityFor = this.services[this.services.indexOf(service)];
            this.showQuantityPicker = true;
            this.services[this.services.indexOf(service)].checked = true;
        },
        setQuantity(qte) {
            this.setQuantityFor.qte = qte;
        },
        disableOtherQueues(service) {
            if (service.checked) {
                if (!JSON.parse(window.localStorage.getItem('kiosk')).allow_sms_ticket && !+JSON.parse(JSON.parse(window.localStorage.getItem('kiosk')).config).allow_multiple_services) {
                    this.showServices = false;
                    this.directPrint = true;
                }
                this.services.forEach((serv) => {
                    if (service.queue_id !== serv.queue_id || (!+JSON.parse(JSON.parse(window.localStorage.getItem("kiosk")).config).allow_multiple_services && serv.id !== service.id)) {
                        serv.checked = false;
                        serv.disabled = true;
                    }
                })
            } else {
                for (let i = 0; i < this.services.length; i++) {
                    if (this.services[i].checked) {
                        return;
                    }
                }
                this.services.forEach((serv) => {
                    serv.disabled = false;
                });
            }
        },
        validateServices() {
            this.cancelTimer();
            this.validating = true;
            let serviceChecked = false;
            this.services.forEach((service) => {
                if (service.checked) {
                    serviceChecked = true;
                }
            });
            if (!serviceChecked) {
                this.validating = false;
                this.showErrorPopup(this.$t('Kiosk.servicesError'));
                return;
            }
            // if(serviceChecked) {
            //     this.playSuccessVoice();
            // }
            if (!JSON.parse(window.localStorage.getItem('kiosk')).allow_sms_ticket)
                this.directPrint = true;
            this.showServices = false;
            this.validating = false;

            if (this.age) {
                localStorage.setItem("sentiment", JSON.stringify({
                    "age": this.age,
                    "gender": this.gender,
                    "expression": this.expression
                }));

            }
            this.allow_sms_ticket = localStorage.getItem("allow_sms_ticket") || 0;
            if(this.allow_sms_ticket == 0) {
                this.playFinalVoice();
            }
            this.stopTimer();
          //  console.log("timer after check", this.timer);

        },
        autoValidateServices() {
            this.cancelTimer();
            this.validating = true;
            let serviceChecked = false;
            serviceChecked = true;

            if (!JSON.parse(window.localStorage.getItem('kiosk')).allow_sms_ticket)
                this.directPrint = true;
            this.showServices = false;
            this.validating = false;

            if (this.age) {
                localStorage.setItem("sentiment", JSON.stringify({
                    "age": this.age,
                    "gender": this.gender,
                    "expression": this.expression
                }));

            }
            this.allow_sms_ticket = localStorage.getItem("allow_sms_ticket") || 0;
            if(this.allow_sms_ticket == 0) {
                this.playFinalVoice();
            }
            this.stopTimer();
           // console.log("timer after check", this.timer);

        },
        setIdleTimeout() {
            clearTimeout(this.idleTimeout);
            if (this.themeTemplate.IdleTimeout && this.allowIdle) {
                this.idleTimeout = setTimeout(() => {
                    window.location.reload();
                }, this.themeTemplate.IdleTimeout)
            }
        },
        cancelIdle() {
            this.allowIdle = false;
            clearTimeout(this.idleTimeout);
        },
        startIdle() {
            this.allowIdle = true;
            this.setIdleTimeout();
        },
        getCategories() {
            if (this.themeTemplate.allowCategory == 1) {
                if (window.localStorage.getItem("categories")) {
                    this.categories = JSON.parse(window.localStorage.getItem('categories'));
                } else {
                    this.loading = true;
                    kioskService.getCategories().then((res) => {
                        this.categories = res.data;
                        localStorage.setItem("categories", JSON.stringify(res.data))
                    }).catch((err) => {
                   //     console.log(err)
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            }
        },
        test() {
          //  console.log("Testing");
        },
        cancel() {
            this.getCategories();
            this.categoryChosen = false;
        },

        getData() {
            this.startTimer();
            this.voice = false;
            this.timerStatus = true;
        },
        consoleMessage() {
          //  console.log("console message from event");
        }
    },
    watch: {
        onLine(v) {
            if (v) {
                location.reload()
            }
        }
    },
    created() {
        this.themeTemplate = JSON.parse(window.localStorage.getItem('theme'));
        this.setIdleTimeout();
        this.setServices();
        document.addEventListener('click', () => {
            this.setIdleTimeout();
        });
        this.getCategories();
    },
    beforeUnmount() {


        // this.echo.channel("private-kioskWaitingQueue-" + this.display.id).stopListening('.ticket-call')
        // this.echo.channel("private-kioskWaitingQueue-" + this.display.id).stopListening('.ticket-recall')
        // window.removeEventListener('online', this.updateOnlineStatus)
        // window.removeEventListener('offline', this.updateOnlineStatus)
    },

    mounted() {
        // Only initialize webcam if AI features are enabled
        if (isAIEnabled()) {
            this.initWebcam();
        } else {
           // console.log('AI features disabled - skipping webcam initialization');
          //  this.loading = false;
        }
        this.language = localStorage.getItem('Language') || 'fr'
        let aiKiosk = JSON.parse(JSON.parse(localStorage.getItem('kiosk')).config_v2).aiKiosk
       // console.log("getBuiness",aiKiosk)
        // let servicesList = this.services.map((service, index) => ({
        //     id: index + 1,
        //     name: service.title
        // }));

        // console.log("constvvvvvvv ",JSON.stringify(servicesList));


    }

}
</script>

<style scoped>
.display-container {
    display: flex;
    position: absolute;
    flex-direction: column;
    justify-content: space-between;
    top: 0;
    left: 0;
    margin: 0;
    height: 100vh;
    width: 100%;
}


.display-image-container img {
    width: 90vh;
}

.display-image-container video {
    width: 90vh;
    height: 90vh;
}

.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    border: 8px solid rgba(0, 0, 0, 0.1);
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>